import axios from 'axios';

const getBaseURL = () => {
  // Use the configured API URL for both development and production.
  // The environment variable REACT_APP_API_URL should point to the deployed backend (e.g., https://api.temple.com).
  // If not set, default to empty string which results in relative calls.
  const url = process.env.REACT_APP_API_URL || '';
  // Strip trailing '/api' if present to avoid double‑/api paths.
  return url.endsWith('/api') ? url.slice(0, -4) : url;
};

// Configure axios base URL
const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 60000, // 60 seconds to accommodate Render cold start
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('temple_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Log request in development
    if (process.env.NODE_ENV === 'development') {
      console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);
    }

    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    // Log response in development
    if (process.env.NODE_ENV === 'development') {
      console.log(`API Response: ${response.status} ${response.config.url}`);
    }
    return response;
  },
  (error) => {
    if (error.response) {
  console.error('API Error:', {
    status: error.response.status,
    data: error.response.data,
    headers: error.response.headers,
  });
} else {
  console.error('API Error (no response):', error.message);
}

    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('temple_token');
      window.location.href = '/login';
    } else if (error.code === 'ECONNABORTED') {
      // Request timeout
      console.error('Request timeout - server may be down');
    } else if (error.code === 'ERR_NETWORK') {
      // Network error
      console.error('Network error - check if server is running');
    }

    return Promise.reject(error);
  }
);

export default api;
